import { render, staticRenderFns } from "./CollaboratorHistoricTable.vue?vue&type=template&id=4e4acd38&scoped=true&"
import script from "./CollaboratorHistoricTable.vue?vue&type=script&lang=js&"
export * from "./CollaboratorHistoricTable.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorHistoricTable.vue?vue&type=style&index=0&id=4e4acd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4acd38",
  null
  
)

export default component.exports